import Repository from './Repository'
const resource = '/settings'

export default {
  /**
   * 検索項目一覧を取得する
   *
   * @param {Array} type 種別 room, building
   */
  async get(type) {
    const params = {
      type: type,
    }
    return await Repository.get(`${resource}/b_list/search_conditions`, { params: params })
      .then(response => {
        return response.data.body
      })
      .catch(e => {
        console.log(e)
      })
  },
  /**
   * 検索項目を保存する
   *
   * @param {Object} search 検索項目
   * @param {Array} tag 検索項目タグ
   * @param {Array} type 種別
   * @param {String} name 保存名
   */
  async post(search, tag, type, name) {
    const params = {
      name: name,
      search: search,
      tag: tag,
      type: type,
    }
    return await Repository.post(`${resource}/b_list/search_conditions`, params)
      .then(response => {
        return response
      })
      .catch(e => {
        console.log(e)
        return e.response
      })
  },
  /**
   * 検索項目を削除する
   *
   * @param {Number} id 検索項目ID
   */
  async delete(id) {
    return await Repository.delete(`${resource}/b_list/search_conditions/${id}`)
      .then(response => {
        return response.data.body
      })
      .catch(e => {
        console.log(e)
      })
  },
}
